import capitalize from 'lodash/capitalize'

export enum FolioView {
  guest = 'guest',
  internal = 'internal',
  owner = 'owner',
  accounting = 'accounting',
}

export const FOLIO_VIEW_OPTIONS = Object.values(FolioView).map(view => ({
  id: view,
  title: capitalize(view),
  value: view,
}))
